import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "sqg-changePassword" }
const _hoisted_2 = { class: "sqg-changePassword__content" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Changer le mot de passe")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Modale = _resolveComponent("Modale")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isOpen)
      ? (_openBlock(), _createBlock(_component_Modale, {
          key: 0,
          width: "30",
          height: "50",
          title: "Changer votre mot de passe",
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.userLoader)
                ? (_openBlock(), _createBlock(_component_Loader, {
                    key: 0,
                    msg: "Modificiation du mot de passe"
                  }))
                : (_openBlock(), _createElementBlock("form", {
                    key: 1,
                    class: "sqg-changePassword__form",
                    onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.changePassword && _ctx.changePassword(...args)), ["prevent"]))
                  }, [
                    _createVNode(_component_Input, {
                      type: "password",
                      placeholder: "Nouveau mot de passe",
                      modelValue: _ctx.password,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_Button, { type: "submit" }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    })
                  ], 32))
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}